import React from 'react'
import Docs from '../../components/page-content/docs'
import { Provider } from '../../components/page-content/docs/context'
import { useAppContext } from '../../hooks/useAppContext'

export const Page = () => {
  const {
    routeContext: { posts, tags },
  } = useAppContext()

  return (
    <Provider posts={posts} tags={tags}>
      <Docs />
    </Provider>
  )
}
export default Page
